__webpack_require__.p = "https://js-static.iimjobs.com/production/6.7.2/_next/";